import React, { FC } from "react";
import { images } from "assets/images";
import { LocalStorageKey, useGetUserData } from "common/helpers/userData";
import { UserRole } from "components/Reports/reportAssets/assets";
import { Image } from "react-bootstrap";

const Logo: FC = () => {
  const userId = useGetUserData(LocalStorageKey.UserId);
  const role = useGetUserData(LocalStorageKey.SelectedRole).value;
  const href =
    role !== UserRole.SENIOR_WATCH
      ? "/reports/inprogress"
      : "/reports/followup";

  // Roadian wordmark is wide (112×27, ~4.15:1); height tuned down from the old
  // ~square SafeLane mark (was 80) so the header wordmark isn't oversized — D-07.
  const logo = <Image src={images.logo} alt="logo" height="40" />;

  return userId ? (
    <a href={href} className="logoBox">
      {logo}
    </a>
  ) : (
    <div className="logoBox">{logo}</div>
  );
};

export default Logo;
